import {Routes} from '@angular/router';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {SettingsComponent} from './components/settings/settings.component';

export const APP_ROUTE_ADMIN = 'admin';
export const APP_ROUTE_WORKFLOW = 'workflow';

export const APP_ROUTES: Routes = [
  {
    path: APP_ROUTE_WORKFLOW,
    loadChildren: () => import('./pages/workflow/workflow.routes').then((m) => m.WORKFLOW_ROUTES),
  },

  {
    path: APP_ROUTE_ADMIN,
    data: {preload: false},
    loadChildren: () => import('./pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: 'help',
    data: {preload: false},
    loadChildren: () => import('./pages/help/help.routes').then((m) => m.HELP_ROUTES),
  },
  {path: 'me/settings', component: SettingsComponent},
  {path: 'not-found', component: NotFoundComponent},
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'workflow',
  },

];
